import ServiceDetails from "../components/ui/ServiceDetails";

export default function ServicesPage() {

    return <>
        <section id="intake" className="m-5 p-5 bg-white rounded-xl shadow-lg">
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Our Services</h2>


            <ServiceDetails title="Accounting & Financial Reporting" img="img/accounting_icon.png" id="accounting">
                <p className="mb-2">
                    <strong>R&Co. Chartered Professional Accountant Prof. Corp.</strong> provides professional
                    accounting and financial reporting services designed to support accurate record-keeping, regulatory
                    compliance, and informed financial decision-making.
                </p>
                <p className="mb-2">
                    Services include <strong>financial reporting and compilation engagements,</strong> accounting and
                    bookkeeping support, and related compliance filings.
                    <strong> Compilation engagements are performed by a licensed Chartered Professional
                        Accountant</strong> in accordance with applicable professional standards and are commonly used
                    for internal management, financing, and reporting purposes.
                </p>
                <p className="mb-2">
                    As part of the accounting process, financial information is reviewed for <strong>completeness,
                    consistency, and proper classification</strong> based on information provided by management, to
                    support
                    reliable financial reporting.
                </p>
                <p className="mb-2">
                    Bookkeeping services involve the systematic recording of financial transactions, including bank
                    reconciliations, journal entries, accounts receivable and payable, and year-end summaries. Support is
                    also provided for GST/HST and PST filings, helping ensure sales tax reporting is prepared accurately and
                    submitted on a timely basis.
                </p>
            </ServiceDetails>

            <ServiceDetails title="Tax Preparation & Tax Planning" img="img/tax_prep.png" id="tax">
                <p className="mb-2">
                    Tax preparation services include the preparation of <strong>personal and corporate income tax returns,</strong> along
                    with related compliance and reporting requirements. Each return is prepared with a focus on
                    accuracy, completeness, and compliance with Canada Revenue Agency requirements.
                </p>

                <p className="mb-2">
                    As part of the tax preparation process, a <strong>comprehensive review of the client’s personal or business
                    situation</strong> is performed. This includes reviewing income sources, family circumstances, and prior-year
                    information to ensure that <strong>all applicable deductions, credits, and elections are considered,</strong> not
                    just those reflected on tax slips.
                </p>

                <p className="mb-2">This review may include, where applicable:</p>
                <ul className="list-disc list-inside pl-4 space-y-1 my-3">
                    <li>Employment, self-employment, rental, and investment income</li>
                    <li>Family-related credits and benefits</li>
                    <li>Tuition, education, and student loan considerations</li>
                    <li>Medical expenses, donations, and other eligible deductions</li>
                    <li>Credits related to home ownership, moving, or other life events</li>
                    <li>Provincial and federal tax credits relevant to the client’s circumstances</li>
                </ul>

                <p className="mb-2">
                    Tax planning services may also be provided to help clients understand current and future tax
                    obligations, plan for upcoming changes, and make informed decisions throughout the year. The
                    objective is to ensure that tax filings are <strong>complete, accurate, and optimized within the framework
                    of applicable tax legislation,</strong> while avoiding omissions or missed opportunities.
                </p>

            </ServiceDetails>

            <ServiceDetails title="Payroll Services" img="img/payroll.png" id="payroll">
                <p className="mb-2">
                    Payroll services support employers in meeting their <strong>ongoing payroll, remittance, and
                    employment
                    reporting obligations</strong> accurately and on time.
                </p>

                <p className="mb-2">
                    Services include payroll processing, calculation of employee wages, statutory deductions, and
                    preparation of required remittances. Payroll is handled with attention to applicable federal and
                    provincial requirements to support compliance and reduce the risk of errors or penalties.
                </p>

                <p className="mb-2">
                    As part of payroll services, a <strong>broader review of payroll-related obligations</strong> may be
                    performed to
                    ensure that employer responsibilities are properly addressed. This may include, where
                    applicable:
                </p>

                <ul className="list-disc list-inside pl-4 space-y-1 my-3">
                    <li>Source deductions and remittances (CPP, EI, income tax)</li>
                    <li>Preparation of <strong>Records of Employment (ROEs)</strong></li>
                    <li>Annual payroll reporting, including <strong>T4 slips and summaries</strong></li>
                    <li>Review of taxable benefits and allowances</li>
                    <li>Assistance with employment-related forms such as <strong>T2200</strong> and <strong>TL2</strong>,
                        where applicable
                    </li>
                </ul>

                <p className="mb-2">
                    Payroll and compliance services may also include <strong>WCB reporting,</strong> including guidance on
                    registration requirements, classification, and preparation of Employer Payment Statements.
                </p>
                <p className="mb-2">
                    The objective of payroll services is to ensure that employee compensation and related reporting are
                    handled accurately, consistently, and in compliance with applicable legislation, allowing employers
                    to focus on their business operations with confidence.
                </p>
            </ServiceDetails>

            <ServiceDetails title="Business Advisory & Planning" img="img/corporate_icon.png" id="advisory">
                <p className="mb-2">
                    Business advisory services are designed to support individuals and business owners at the <strong>early
                    stages of starting or structuring a business,</strong> as well as during key transition points.
                </p>

                <p className="mb-2">
                    Services include guidance on <strong>whether to operate as a sole proprietor (self-employed) or incorporate,</strong>
                    taking into account factors such as income levels, tax considerations, liability, future growth
                    plans, and administrative requirements. Each option has different tax, legal, and compliance
                    implications, and professional guidance can help determine the most appropriate structure.
                </p>

                <p className="mb-2">
                    Advisory support may also include assistance with:
                </p>

                <ul className="list-disc list-inside pl-4 space-y-1 my-3">
                    <li>Business registration and setup considerations</li>
                    <li>Understanding tax obligations and filing requirements</li>
                    <li>Planning for GST/HST and PST registration</li>
                    <li>Payroll and employer responsibilities</li>
                    <li>Record-keeping and compliance expectations</li>
                    <li>Budgeting, cash flow considerations, and financial organization</li>
                </ul>

                <p className="mb-2">
                    In addition, <a href="#notary"><strong>notary public services</strong></a> are available as part of administrative support, including
                    notarization and certification of documents where required.
                </p>

                <p className="mb-2">
                    These services are intended to help clients start their business with clarity, avoid common
                    mistakes, and establish a strong foundation for ongoing compliance and financial management.
                </p>
            </ServiceDetails>

            <ServiceDetails title="Insurance Solutions" img="img/insur_sol.png" id="insurance">
                <p className="mb-2">
                    Insurance services are offered as a <strong>complementary service</strong> to accounting and tax planning, where
                    appropriate and in accordance with applicable licensing requirements.
                </p>
                <p className="mb-2">
                    These services may include general guidance related to <strong>life, health, disability, critical illness,
                    travel, and visitor insurance.</strong> Insurance services are provided separately from accounting and tax
                    services.
                </p>

                <div className="mt-4 flex justify-center">
                    <button
                        className="mx-auto inline-flex items-center gap-2 px-4 py-2 bg-[#1C3353] text-white rounded-lg font-medium transition-all duration-300 hover:bg-gradient-to-b hover:from-[#F6D28B] hover:to-[#F1C169] hover:text-[#1C3353] hover:shadow-lg hover:shadow-yellow-500/30 group mx-auto">
                        Learn more about insurance solutions
                        <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                    </button>
                </div>
            </ServiceDetails>

            <ServiceDetails title="Investment Guidance" img="img/investment_icon.png" id="investment">
                <p className="mb-2">
                    Investment guidance is available as a <strong>complementary service</strong> to support registered savings and
                    financial planning considerations.
                </p>
                <p className="mb-2 pb-1">
                    This may include general guidance related to <strong>RRSP, TFSA, FHSA, and RESP</strong> accounts.
                    Investment services are provided separately from accounting and tax services and are subject to
                    applicable regulatory requirements.
                </p>

                <div className="mt-4 flex justify-center">
                    <button
                        className="mx-auto inline-flex items-center gap-2 px-4 py-2 bg-[#1C3353] text-white rounded-lg font-medium transition-all duration-300 hover:bg-gradient-to-b hover:from-[#F6D28B] hover:to-[#F1C169] hover:text-[#1C3353] hover:shadow-lg hover:shadow-yellow-500/30 group mx-auto">
                        Learn more about investment services
                        <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                    </button>
                </div>


            </ServiceDetails>

            <ServiceDetails title="Notary Public Services" img="img/notary_icon.png" id="notary">
                <h4 className="text-l font-semibold text-[#0a2540]">Document Certification</h4>
                <p className="mb-2">
                    We certify the authenticity of documents by verifying signatures and confirming that copies are true
                    and accurate representations of the original documents. Certified copies may be required for various
                    purposes, such as legal proceedings, immigration applications, or financial transactions.
                </p>

                <h3 className="text-l font-semibold text-[#0a2540]">Witnessing Signatures</h3>
                <p className="mb-2">
                    One of the primary roles of Notaries Public is to witness the signing of legal documents, contracts,
                    affidavits, statutory declarations, and other instruments requiring authentication. Our Notaries
                    ensure that signatories are properly identified and that signatures are executed voluntarily and
                    with understanding.
                </p>

                <h3 className="text-l font-semibold text-[#0a2540]">Administering Oaths and Affirmations</h3>
                <p className="mb-2">
                    Notaries Public have the authority to administer oaths and affirmations to individuals making sworn
                    statements or declarations. This includes witnessing the swearing of affidavits or statutory
                    declarations, which are often used as evidence in legal proceedings or administrative matters.
                </p>

                <h3 className="text-l font-semibold text-[#0a2540]">Legalization and Notarization for International Use</h3>
                <p className="mb-2">
                    We notarize documents for international use, such as powers of attorney, contracts, and business
                    agreements. In some cases, notarized documents may require further authentication through the
                    process of legalization or apostille to be recognized in foreign jurisdictions.
                </p>
                <p className="mb-2">
                    Canada has joined the Apostille Convention, which simplifies the process of getting Canadian
                    documents authenticated. The apostille eliminates steps required to get documents accepted in
                    countries where the convention is in effect, including legalization by a consular office of the
                    country of destination. Canadian citizens and businesses can submit Canadian public documents – such
                    as birth and marriage certificates, education, court, or notarized documents – for an authenticity
                    certificate called an Apostille. This certificate will allow the documents to be used in any of the
                    countries that are members of the convention.
                    <a href="https://www.hcch.net/en/instruments/conventions/status-table/?cid=41&fbclid=IwAR3xE-tQxTducF-UUgDAzkeZJkSSgrOV9P7UWl9KdWB5i1YJd44M5AKXRjU"
                       className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"> Learn more</a>
                </p>

                <h3 className="text-l font-semibold text-[#0a2540]">Compliance with Notarial Standards</h3>
                <p className="mb-2">
                    Our Notaries Public are bound by provincial legislation, regulations, and professional standards
                    governing their practice. They adhere to ethical principles, maintain confidentiality, and exercise
                    impartiality and integrity in performing their duties.
                </p>

                <h3 className="text-l font-semibold text-[#0a2540]">Translations</h3>
                <p className="mb-2">
                    Our Notaries Public cooperate with translators in case your document is not in English, or you need
                    the notarized translation of your English document.
                </p>

                <h3 className="text-l font-semibold text-[#0a2540]">Limitations on Legal Advice</h3>
                <p className="mb-2">
                    While our Notaries Public are authorized to provide guidance on notarial procedures, document
                    execution, and certification requirements, they are not licensed to offer legal advice or
                    representation. Clients seeking legal interpretation or advice on specific legal matters should
                    consult with a qualified lawyer or legal professional.
                </p>
            </ServiceDetails>
        </section>
    </>
        ;
}